import Vue from "vue";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);

var DEFAULT_LANG = "en";

var savedLan = localStorage.getItem('lan');

if (savedLan) {
  DEFAULT_LANG = savedLan;

}

const locales = {
  en: require("./i18n/en.json"),
  zh: require("./i18n/zh.json"),
  in: require("./i18n/in.json"),
  my: require("./i18n/my.json"),
  th: require("./i18n/th.json"),
  vn: require("./i18n/vn.json"),
};
const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales
});

export default i18n;
